import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import DetalheBagagem from './DetalheBagagem'
import { alterarExibicaoBagagem, excluirBagagem, buscarBagagens, selecionaBagagem } from '../../actions/bagagem/bagagemActions';

export class Bagagem extends React.Component {
  state = {
    showModal: false,
    bagagemSelecionada: null,
  };

  getBadgeVariant(situacao) {
    if (!situacao) return 'default';
    const s = String(situacao).toLowerCase();
    if (s.includes('aprov') || (s.includes('ativ') && !s.includes('inativ'))) return 'confirmado';
    if (s.includes('inativ') || s.includes('cancel')) return 'cancelado';
    if (s.includes('pendent') || s.includes('em aberto')) return 'pendente';
    return 'default';
  }

  abrirModal = (id) => {
    this.setState({ showModal: true, bagagemSelecionada: id });
  };

  fecharModal = () => {
    this.setState({ showModal: false, bagagemSelecionada: null });
  };

  selecionaBagagem = (bagagem) => {
    this.props.selecionaBagagem(bagagem);
    this.props.history.push('/recibo-bagagem');
  }

  confirmarRemocao = () => {
    if (this.state.bagagemSelecionada) {
      this.props.excluirBagagem(this.state.bagagemSelecionada);
    }
    this.props.buscarBagagens(this.props.empresaSelecionada.id);
    this.fecharModal();
  };

  render() {
    const b = this.props.bagagem

    return (
      <div className="vx-row-item">
        <div className="vx-row-item-inner vx-row-item-inner--bagagem">

          <div className="vx-row-cell">
            <button type="button" className="vx-row-expand-btn"
                    onClick={() => this.props.alterarExibicaoBagagem(this.props.bagagem)}>
              <span className="material-icons">
                {b.exibirDetalhe ? 'expand_less' : 'expand_more'}
              </span>
            </button>
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Nº Reserva</div>
            {b.reservaId}
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Identificador</div>
            {b.codigoRastreio}
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Passageiro</div>
            {b.nomePassageiro}
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Vendedor</div>
            {b.nomeVendedor}
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Situação</div>
            <span className={`vx-remark-badge vx-remark-badge--${this.getBadgeVariant(b.situacao)}`}>
              {b.situacao}
            </span>
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Data emissão</div>
            <Moment format="DD/MM/YYYY">{b.dataHoraRegistro}</Moment>
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Valor</div>
            {b.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || 'R$ 0,00'}
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Peso</div>
            {b.peso
              ? `${b.peso.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kg`
              : '0,00 kg'}
          </div>

          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Ações</div>
            <div className="vx-row-actions">
              {b.habilitadoCancelamento && (
                <button type="button" className="vx-bag-btn vx-bag-btn--cancel"
                        disabled={!b.ativa}
                        onClick={() => this.abrirModal(b.id)}>
                  <span className="material-icons">delete</span>
                  Cancelar
                </button>
              )}
              {/* igual a Emitir Cupom da reserva: pendente (Sicoob PIX não pago) não emite cupom */}
              {b.situacao !== 'PENDENTE' && (
                <button type="button" className="vx-bag-btn vx-bag-btn--receipt"
                        onClick={() => this.selecionaBagagem(b)}>
                  <span className="material-icons">receipt</span>
                  Cupom
                </button>
              )}
            </div>
          </div>
        </div>

        <DetalheBagagem bagagem={b}/>

        {this.state.showModal && (
          <React.Fragment>
            <div className="modal fade show" style={{display: 'block', zIndex: 1050}} role="dialog">
              <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>
                  <div className="vx-modal-header">
                    <div className="vx-modal-title">
                      <span className="material-icons">warning</span>
                      Cancelar Bagagem
                    </div>
                    <button type="button" className="vx-modal-close" onClick={this.fecharModal}>
                      <span className="material-icons">close</span>
                    </button>
                  </div>
                  <div className="vx-modal-body" style={{background: '#fff'}}>
                    <p style={{margin: 0, fontSize: 14, color: '#444'}}>
                      Tem certeza que deseja cancelar esta bagagem? Esta ação não pode ser desfeita.
                    </p>
                  </div>
                  <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" onClick={this.fecharModal}>
                      Não
                    </button>
                    <button type="button" className="vx-modal-btn-confirmar"
                            style={{background: 'linear-gradient(135deg,#c62828 0%,#b71c1c 100%)'}}
                            onClick={this.confirmarRemocao}>
                      <span className="material-icons" style={{fontSize: 15}}>delete</span>
                      Sim, cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade show" style={{zIndex: 1040}}/>
          </React.Fragment>
        )}
      </div>
    )
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
})

export default connect(mapStateToProps, {
  alterarExibicaoBagagem,
  excluirBagagem,
  buscarBagagens,
  selecionaBagagem,
})(withRouter(Bagagem));
